import { Alert } from 'react-native';

/**
 * Buluşma güncellendiğinde diğer katılımcılara push hazırlığı; şimdilik yer tutucu (Alert).
 */
export function notifyEventUpdatedToParticipants(
  eventTitle: string,
  otherParticipantCount: number,
): void {
  if (otherParticipantCount <= 0) {
    return;
  }
  Alert.alert(
    'Buluşma güncellendi',
    `“${eventTitle}” güncellendi. ${otherParticipantCount} katılımcıya bildirim gönderme altyapısı yakında devreye alınacak.`,
  );
}
